import injectEmbroideryAttributes from "../../components/SvgEditor/helpers/injectEmbroideryAttributes";

export const SATIN_DEFAULTS = {
  stitchType: "satin",
  pull_compensation_mm: 0.2,
  push_compensation_mm: 0,
  zigzag_spacing_mm: 0.4,
  max_stitch_length_mm: 7,
  split_method: "staggered",
  split_staggers: 4,
  short_stitch_distance_mm: 0.25,
  short_stitch_inset: 15,
  fill_underlay: true,
  satin_underlay_profile: "auto",
  contour_underlay_inset_mm: 0.4,
  zigzag_underlay_spacing_mm: 3,
  reverse_rails: "automatic",
  swap_satin_rails: false,
};

export function assembleDesign(svg, routes, size) {
  const children = [],
    settings = {},
    rails = {},
    decisions = [];
  const sorted = [...routes].sort((a, b) => a.index - b.index);
  if (
    sorted.length !== svg.children.length ||
    sorted.some((r, i) => r.index !== i)
  )
    throw new Error("The analysis does not match the traced layers.");
  for (const route of sorted) {
    if (route.choice === "background") {
      decisions.push({ ...route, outputIndex: null });
      continue;
    }
    if (!["fill", "satin"].includes(route.choice) || (route.choice !== "satin" && route.status !== "ready"))
      throw new Error(`Layer ${route.index + 1} is not ready for export.`);
    const index = children.length;
    children.push(svg.children[route.index]);
    if (route.choice === "satin") {
      const result = route.result || {};
      const unresolved = Array.isArray(result.unresolved)
        ? result.unresolved.length : result.unresolved;
      rails[index] = {
        pairs: result.pairs || [],
        autoCuts: result.cuts || [],
        autoSatinBeta: true,
        autoSatinPartial: !result.complete || !!unresolved || !result.pairs?.length,
        autoIssues: result.issues || [],
        autoUnresolvedPieces: result.unresolvedPieces || [],
      };
    }
    settings[index] = {
      activePassIndex: 0,
      passes: [
        {
          id: "pass_0",
          ...(route.choice === "satin"
            ? SATIN_DEFAULTS
            : {
                stitchType: "auto_fill",
                fill_method: "auto_fill",
                angle: route.angle,
                row_spacing_mm: 0.4,
                max_stitch_length_mm: 3,
                staggers: 4,
                fill_underlay: true,
                fill_underlay_row_spacing_mm: 2,
                fill_underlay_angle: (route.angle + 90) % 180,
              }),
        },
      ],
    };
    decisions.push({
      index: route.index,
      outputIndex: index,
      choice: route.choice,
      angle: route.angle,
      reason: route.reason,
    });
  }
  if (!children.length) throw new Error("No stitchable layers remain.");
  const editableSvg = {
    ...svg,
    attributes: {
      ...svg.attributes,
      width: `${size.width}mm`,
      height: `${size.height}mm`,
      preserveAspectRatio: "none",
    },
    children,
  };
  return {
    svg: editableSvg,
    settings,
    rails,
    complete: !Object.values(rails).some((entry) => entry.autoSatinPartial),
    decisions,
    exportSvg: injectEmbroideryAttributes(editableSvg, settings, rails),
  };
}
